import $ from 'jquery';
import 'jquery-menu-aim';

/* global Modernizr */

class NavigationDesktop {
  constructor() {
    this.activeItem = null;
    this.toggle();
  }

  initDesktop() {
    const obj = this;
    $('.hdr-p-list, .hdr-p-right').menuAim({
      rowSelector: '> .hdr-p-list-item',
      submenuDirection: 'below',
      activate: obj.enterMenuItem,
      deactivate: obj.exitMenuItem,
      exitMenu: obj.exitMenu,
    });
  }

  // uninitDesktop() {
  //   $('.hdr-p-list, .hdr-p-right').menuAim({ uninit: true });
  // }

  initMobile() {
    const obj = this;

    $('.hdr-p-list-item, .hdr-s-list-item').on('click.noTouchNav', function(
      event,
    ) {
      event.stopPropagation();
      if (this !== obj.activeItem) {
        obj.exitMenuItem(obj.activeItem);
        obj.enterMenuItem(this);
        obj.activeItem = this;
      } else {
        obj.exitMenuItem(obj.activeItem);
        obj.activeItem = null;
      }
    });

    $('.hdr-dropdown').on('click.noTouchNav', event => {
      event.stopPropagation();
    });

    $('.hdr-p-list-item, .hdr-s-list-item').on(
      'touchstart.noTouchNav',
      event => {
        event.stopPropagation();
      },
    );

    $('body').on('touchstart.noTouchNav', () => {
      obj.exitMenuItem(obj.activeItem);
      obj.activeItem = null;
    });
  }

  // uninitMobile() {
  //   $('.hdr-p-list-item').off('click.noTouchNav');
  // }

  toggle() {
    if (this.isDesktop()) {
      // this.uninitMobile();
      this.initDesktop();
    } else {
      // this.uninitDesktop();
      this.initMobile();
    }
  }

  enterMenuItem(row) {
    $(row).addClass('is-hovered');
  }

  exitMenuItem(row) {
    $(row).removeClass('is-hovered');
  }

  exitMenu() {
    return true;
  }

  isDesktop() {
    if (Modernizr.touchevents) return false;
    if (Modernizr.mq('max-width: 767px')) return false;
    return true;
  }

  // bindEvents() {
  //   window.addEventListener('resize', (event) => {
  //     this.toggle();
  //   });
  // }
}

export default new NavigationDesktop();



// WEBPACK FOOTER //
// ./src/js/navigation-desktop.js